import { create } from 'zustand';
import type { ProfFigureSelection } from '../types/prof-figure';

export interface ActiveProfFigureSelection extends ProfFigureSelection {
  topicKey: string;
  pathname: string;
  selectionId: string;
}

export const useActiveProfFigure = create<{
  selection: ActiveProfFigureSelection | null;
  setSelection: (selection: ActiveProfFigureSelection) => void;
  clearSelection: (selectionId?: string) => void;
}>((set) => ({
  selection: null,
  setSelection: (selection) => set({ selection }),
  clearSelection: (selectionId) => set((s) => (
    selectionId && s.selection?.selectionId !== selectionId ? s : { selection: null }
  )),
}));
